import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import PaymentModesForm from 'components/payment/PaymentModesForm';

export default class PaymentModesView extends Component {

  static propTypes = {
    // PaymentMode
    onSitePaymentModes: PropTypes.number,

    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool.isRequired,
  };

  //
  // Renderers
  //

  renderBody() {
    return (
      <div>
        <h3>Paiement sur place</h3>

        <p>Définissez ici les différents modes de paiement acceptés par votre restaurant.</p>

        {this.renderPaymentModesForm()}
      </div>
    );
  }

  renderPaymentModesForm() {
    return (
      <PaymentModesForm
        paymentModes={this.props.onSitePaymentModes}
        onChange={this.props.onChange}
        readOnly={this.props.readOnly}
      />
    );
  }

  render() {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  }

}
